<template>
  <div>
    <b-row class="justify-content-center align-items-center manual-input">
      <b-col sm="12" md="6">
        <b-form-input
        ref="kode"
        size="lg"
        v-model="code"
        v-on:keyup.enter="search"
        placeholder="Scan EAN code"></b-form-input>
        <br>
        <b-button
        @click="search"
        :disabled="code.length < 6"
        variant="danger"
        block size="lg">
          Manual Search
        </b-button>
      </b-col>
  </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: '',
      ticker: null,
    };
  },
  mounted() {
    this.ticker = setInterval(() => {
      this.focusInput();
    }, 1000);
  },
  beforeDestroy() {
    if (this.ticker) clearInterval(this.ticker);
  },
  methods: {
    search() {
      if (this.code.length < 6) return;
      this.$router.push({ name: 'quantity', params: { ean: this.code } });
    },
    focusInput() {
      this.$refs.kode.focus();
    },
  },
};
</script>
<style lang="css">
.manual-input {
  height: 93vh;
  padding: 20px;
}
</style>
